import { Caption, Grid, Paper, Paragraph } from '@ingeniorforeningen/figurine-core';
import { useHistory } from 'react-router-dom';
import { TAlign } from '@ingeniorforeningen/figurine-core/build/types';
import { AppLanguage, UiCase } from '../../types';
import { ROUTE } from '../../App';

type Props = {
  cardCase: UiCase;
  language: string;
};

type CaseInfoProps = {
  index: number;
  span: number;
  align?: TAlign;
};

export const Card = ({ cardCase, language }: Props) => {
  const history = useHistory();

  const CaseInfo = ({ index, align, ...rest }: CaseInfoProps) => (
    <Grid item spacing={0} {...rest}>
      <Caption text={Object.keys(cardCase)[index]} color="gray" align={align || 'left'} />
      <Paragraph strong text={cardCase[Object.keys(cardCase)[index]]} align={align || 'left'} />
    </Grid>
  );

  return (
    <Paper
      mb="md"
      style={{ width: '100%' }}
      onClick={() =>
        history.push(
          language === AppLanguage.English
            ? `${ROUTE.CASE_DETAILS.ENGLISH}/${cardCase.Id}`
            : `${ROUTE.CASE_DETAILS.DANISH}/${cardCase.Id}`,
        )
      }
    >
      <Grid container p="sm">
        <CaseInfo index={0} span={12} />
        <CaseInfo index={1} span={6} />
        <CaseInfo index={2} span={6} align="right" />
        <CaseInfo index={3} span={12} />
        <CaseInfo index={4} span={12} />
      </Grid>
    </Paper>
  );
};
